/**
 * Analytics Error Handler
 * Analytics event'lerinde oluşan hataları yönetir
 */
export const errorManager = {
  logError: (error) => {
    console.error(`Analytics Hata (${error.event}): ${error.message}`);
    // Opsiyonel: hataları bir hata izleme hizmetine gönderin
    // Örnek: Sentry, LogRocket, vb.
  },
};
